export default "__VITE_ASSET__DLXc$GUj__"